import React, { useLayoutEffect, useMemo } from 'react';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import NavigationCloseButton from 'design-system/NavigationCloseButton';
import { isNotNullable } from 'utils/isNotNullable';
import ReasonsScreenContent, { useBankAccessReasonItem, useReferenceChangeReasonItem, useSyncReasonItem, } from '../components/ReasonsScreenContent';
const strings = {
    title: 'Why is the payment missing?',
    subtitle: "If you've already paid but it's not showing, here are the most common reasons",
    renewBankAccessButton: 'Check bank connections',
};
const MissingPaymentReasonsScreen = withAnimatedNavigationHeader(({ navigation, onScroll }) => {
    useLayoutEffect(() => {
        navigation.setOptions({
            headerLeft: () => (<NavigationCloseButton onPress={() => navigation.goBack()}/>),
        });
    }, [navigation]);
    const syncItem = useSyncReasonItem();
    const bankAccessItem = useBankAccessReasonItem(strings.renewBankAccessButton);
    const referenceChangeItem = useReferenceChangeReasonItem();
    const items = useMemo(() => [syncItem, bankAccessItem, referenceChangeItem].filter(isNotNullable), [syncItem, bankAccessItem, referenceChangeItem]);
    return (<ReasonsScreenContent onScroll={onScroll} title={strings.title} subtitle={strings.subtitle} items={items} withBottomPadding/>);
}, () => ({}));
export default MissingPaymentReasonsScreen;
